import { InfoLabel, Text, makeStyles, mergeClasses, typographyStyles } from '@fluentui/react-components';
import { Row } from './Row';
import { Column, ColumnProps } from './Column';
import { useMediaSizes } from './Styles/useMediaSizes';
import { appTokens } from './Styles/appTokens';

const useStyles = makeStyles({
    headerRow: {
        //overflowX: 'hidden',
    },
    headerRowBorder: {
        borderBottom: `1px solid ${appTokens.border.colors.subtle}`,
    },
    title: {
        pointerEvents: 'none',
        userSelect: 'none',
    },
    icon: {
        ...typographyStyles.subtitle1,
    },
    iconMobile: {
        ...typographyStyles.subtitle2,
    },
    actions: {
        '&>button': {
            fontSize: '13px',
            ':focus': {
                outline: 'none',
                boxShadow: 'none',
            },
        },
    },
    disabled: {
        color: appTokens.foregrounds.disabled,
    },
});

export type CustomCardHeaderProps = {
    className?: string;
    title?: string | JSX.Element;
    titleClassName?: string;
    description?: string | JSX.Element;
    action?: JSX.Element;
    headerComponent?: JSX.Element;
    headerComponentProps?: ColumnProps;
    onClick?: () => void;
    icon?: JSX.Element;
    disabled?: boolean;
    info?: string | JSX.Element;
    border?: boolean;
    padding?: string;
    titleWeight?: 'regular' | 'semibold' | 'bold';
    maxWidth?: string;
};

export const CustomCardHeader = (props: CustomCardHeaderProps) => {
    const {
        className,
        title,
        description,
        action,
        onClick,
        titleClassName,
        icon,
        headerComponent,
        headerComponentProps,
        disabled = false,
        info,
        border = false,
        padding = 'py-1',
        titleWeight = 'bold',
        maxWidth = undefined,
    } = props;

    //Hooks
    const mediaSizes = useMediaSizes();

    //Styles
    const styles = useStyles();
    const headerClasses = mergeClasses(styles.headerRow, border && styles.headerRowBorder, className);
    const titleClasses = mergeClasses(styles.title, disabled && styles.disabled, titleClassName);
    const iconClasses = mergeClasses(styles.icon, mediaSizes.isMobile && styles.iconMobile);

    return (
        <Column noGap width='100%'>
            <Row
                className={headerClasses}
                onClick={onClick}
                width='100%'
                height='fit-content'
                padding={padding || 'py-1'}
                gap='small'
                justifyContent='space-between'
            >
                {(!!icon || !!title || !!description) && (
                    <Column vAlign='top' noGap width='auto' maxWidth={maxWidth} overflowX='clip' align='left'>
                        <Row noWrap gap='small' justifyContent='space-between' width='auto'>
                            <Column width='auto' vAlign='middle' className={iconClasses}>
                                {icon}
                            </Column>
                            <Column noGap width='auto' vAlign='middle'>
                                <InfoLabel info={info}>
                                    {typeof title === 'string' ? (
                                        <Text size={mediaSizes.isMobile ? 300 : 400} weight={titleWeight} className={titleClasses}>
                                            {title}
                                        </Text>
                                    ) : (
                                        <>{title}</>
                                    )}
                                </InfoLabel>
                            </Column>
                        </Row>
                        {!!description &&
                            (typeof description === 'string' ? (
                                <Text size={200}>{description}</Text>
                            ) : (
                                <>{description}</>
                            ))}
                    </Column>
                )}
                {!!headerComponent && (
                    <Column className={styles.actions} vAlign='top' {...headerComponentProps}>
                        {!!headerComponent && <>{headerComponent}</>}
                    </Column>
                )}
                {!!action && (
                    <Column className={styles.actions} width='auto' vAlign='top'>
                        {action}
                    </Column>
                )}
            </Row>
        </Column>
    );
};
